import React, { useEffect, useState } from 'react'

import { firestore } from '../firebase';
import { 
    collection,
    getDocs
} from "firebase/firestore";


const NextEvent = () => {

  const [eventos, setEventos] = useState([])

  useEffect(() => {
    async function fetchData() {
        const querySnapshot = await getDocs(collection(firestore, "eventos"));
        querySnapshot.forEach((doc) => {
            setEventos(((prev) => [...prev, doc.data()]))
        })
        ;
      }
      fetchData();
    }, [])

  return (
    <div>
    <section className="page-heading">
    <div className="container">
      <h2>Proximos eventos</h2>
    </div>
  </section>
  <section
    className="events-section"
    itemProp="event"
    itemScope=""
    itemType=" http://schema.org/Event"
  >
    <div className="container events">
      {eventos.map((evento)=>{
        return       <div className="event-wrap" key={evento.url}>
        <div className="img-wrap" itemProp="image">
          <img src={evento.url} alt="event images" loading='lazy'/>
        </div>
        <div className="details">
          <a href="">
            <h3 itemProp="name">{evento.nombre}</h3>
          </a>
          <p itemProp="description">
            {evento.descripcion}
          </p>
          <h5 itemProp="startDate">
            <i className="far fa-clock" /> {evento.fecha}
          </h5>
          <h5 itemProp="location">
            <i className="fas fa-map-marker-alt" /> {evento.ubicacion}
          </h5>
        </div>
      </div>
      })}

    </div>
  </section>
  </div>
  )
}

export default NextEvent